import { Listing } from "../schemas/calendar";

export const getBookingStatusChipColor = (status: string) => {
  switch (status.toLowerCase()) {
    case "confirmed":
      return "success";
    case "pending":
      return "warning";
    case "send_invoice":
      return "primary";
    case "pay_at_counter":
      return "warning";
    case "group_on":
      return "secondary";
    case "cancelled":
      return "error";
    case "invoice_sent":
      return "info";
    default:
      return "default";
  }
};

export const getMembershipStatusChipColor = (status: string) => {
  switch (status.toLowerCase()) {
    case "active":
      return "success";
    case "expired":
      return "error";
    case "pending":
      return "warning";
    case "cancelled":
      return "error";
    case "suspended":
      return "warning";
    default:
      return "default";
  }
};

export const getColorByType = (listing: Listing) => {
  switch (listing.type) {
    case "cage":
      return "#6FE6FC"; // blue
    case "lane":
      return "#388e3c"; // green
    case "full_facility":
      return "#fbc02d"; // amber
    case "training_cage":
      return "#C59560"; 
    default:
      return "#757575"; // grey fallback
  }
};